import React, { useEffect } from 'react'
interface IProps {}

const Heikoop: React.FC<IProps> = (props) => {
  return (
    <>
      {/* Hello world */}
      <svg
        id="svg1"
        width="160"
        height="80"
        version="1.1"
        viewBox="0 0 429.37 214.21"
        xmlSpace="preserve"
        xmlns="http://www.w3.org/2000/svg"
        className="heikoop"
      >
        <g id="g5" transform="translate(-68.78 -221.45)">
          <g id="group-R5">
            <path
              id="path45"
              d="m498.09 271.26h-429.24v-49.741h429.24z"
              fill="#be0019"
              stroke="#fff"
              strokeWidth=".133"
            />
            <path id="path46" d="m491.26 434.97h-415.59v-163.71h415.59z" />
            <g id="g1" fill="#ff0">
              <path
                id="yellow-bg"
                className="deur-flicker"
                d="m475.74 435.67h-121.51v-152.7h121.51z"
              />
              <rect
                id="deur-r"
                x="357.15"
                y="285.66"
                width="55.583"
                height="147.31"
                fill="#000"
                stroke="#000"
                strokeWidth={4}
              />
              <rect
                id="deur-l"
                x="417.26"
                y="285.65"
                width="55.176"
                height="147.33"
                stroke="#000"
                strokeWidth={4}
              />
            </g>
          </g>
          <g strokeLinecap="round">
            <g
              id="g456"
              transform="translate(-2.9637 -.2615)"
              fill="#fff"
              stroke="#fff"
              strokeWidth={2}
            >
              <path id="path3" d="m347.45 237.44 7.1477 20.571" />
              <path id="path4" d="m354.81 257.96 93.312-0.49309" />
              <path id="path2" d="m340.29 237.31 6.9605 0.14442" />
              <path
                id="path14"
                transform="translate(2.9637 .2615)"
                d="m369.76 252.61h-19.613"
              />
              <path
                id="path15"
                transform="translate(2.9637 .2615)"
                d="m372.81 239.62-2.9637 12.988"
              />
              <path
                id="path16"
                transform="translate(2.9637 .2615)"
                d="m348.58 239.8 24.145-0.2615"
              />
              <path
                id="path17"
                transform="translate(2.9637 .2615)"
                d="m339.69 247.03 12.639-0.0872"
              />
              <path
                id="path20"
                transform="translate(2.9637 .2615)"
                d="m334.9 242.15h7.4092"
              />
              <path
                id="path21"
                transform="translate(2.9637 .2615)"
                d="m334.9 252h9.5012"
              />
              <path
                id="path22"
                transform="translate(2.9637 .2615)"
                d="m351.46 233h6.0145"
              />
              <path
                id="path23"
                transform="translate(2.7893 .2615)"
                d="m357.82 237.09v-3.9225"
              />
              <path
                id="path24"
                transform="translate(2.7893 .43583)"
                d="m351.72 237.18c-0.0291-1.3947-0.0581-2.7893-0.0872-4.184"
              />
            </g>
            <g id="g2" fill="#fff" stroke="#fff" strokeWidth={2}>
              <path id="path25" d="m354.07 228.03h7.1477" />
              <path id="path27" d="m353.9 232.91v-4.707" />
              <path id="path28" d="m361.22 231.69v-3.3995" />
            </g>
            <g id="g4" fill="none">
              <g id="g3" stroke="#fff" strokeWidth={2}>
                <path
                  id="path29"
                  d="m361.22 237.09 7.1477-11.68s5.1426-3.5233 5.4044 2.9637c-0.61017 1.6562-5.0557 8.8038-5.0557 8.8038"
                />
                <circle id="path30" cx="356.87" cy="264.17" r="2.8353" />
                <circle id="circle30" cx={366} cy="264.17" r="2.8353" />
              </g>
              <path
                id="text30"
                d="m389.48 238.27q0.53333 0 0.83199 0.36266 0.31999 0.36266 0.21333 0.87465l-2.1546 12.458q-0.10667 0.512-0.53333 0.87466-0.40533 0.36266-0.93865 0.36266-0.51199 0-0.83199-0.36266-0.29866-0.36266-0.192-0.87466l0.85332-4.9919h-5.5892l-0.85332 4.9919q-0.10667 0.512-0.53333 0.87466t-0.93865 0.36266-0.83199-0.36266q-0.29866-0.36266-0.19199-0.87466l2.1546-12.458q0.10667-0.51199 0.51199-0.87465 0.42666-0.36266 0.93865-0.36266 0.512 0 0.83199 0.36266 0.32 0.36266 0.21333 0.87465l-0.87465 4.9919h5.5892l0.87466-4.9919q0.10666-0.51199 0.51199-0.87465 0.42666-0.36266 0.93865-0.36266zm7.0346 14.933q-0.29866 0-0.38399-0.0213-2.0053-0.10667-2.9226-1.5786-0.85332-1.3653-0.49066-3.3919 0.192-1.024 0.68266-1.92 0.51199-0.91732 1.216-1.5786 0.70399-0.68265 1.5573-1.0666 0.87465-0.40532 1.7706-0.40532 0.89598 0 1.6213 0.36266 0.74666 0.36266 1.2373 1.0453 0.49066 0.66132 0.66132 1.536 0.17066 0.85332 0 1.8133-0.10666 0.51199-0.53332 0.89598-0.40533 0.36266-0.91732 0.36266h-4.8426q0.0213 0.256 0.10666 0.512 0.10667 0.25599 0.27733 0.46932 0.17066 0.192 0.44799 0.32 0.27733 0.12799 0.68266 0.14933h0.128q0.23466 0 0.63999-0.0427 0.42666-0.0427 0.87465-0.34133 0.34133-0.19199 0.72532-0.19199 0.29866 0 0.55466 0.14933 0.256 0.128 0.38399 0.40532 0.17067 0.29867 0.10667 0.66133-0.064 0.29866-0.27733 0.59732-0.192 0.29866-0.49066 0.46933-0.87465 0.51199-1.6213 0.66132-0.74665 0.128-1.1946 0.128zm-0.68265-6.4426h3.0933q-0.12799-0.49066-0.42666-0.72532-0.27733-0.256-0.93865-0.256-0.61866 0-1.0026 0.256t-0.72532 0.72532zm9.6799 6.4426q-0.512 0-0.83199-0.36266-0.29866-0.36266-0.192-0.87466l1.28-7.4666q0.10667-0.51199 0.53333-0.87465 0.42666-0.38399 0.93865-0.38399t0.81065 0.38399q0.32 0.36266 0.21333 0.87465l-1.28 7.4666q-0.10666 0.512-0.53332 0.87466t-0.93865 0.36266zm3.5199-13.056q-0.10666 0.53333-0.53332 0.89599t-0.93866 0.36266q-0.51199 0-0.83198-0.36266-0.29867-0.36266-0.192-0.89599 0.0853-0.51199 0.51199-0.87465 0.42666-0.36266 0.93865-0.36266 0.512 0 0.81066 0.36266 0.31999 0.36266 0.23466 0.87465zm9.5306 10.922q0.17067 0.21333 0.21333 0.44799 0.0427 0.21333 0 0.44799-0.10666 0.512-0.53332 0.87466-0.40533 0.36266-0.91732 0.36266t-0.83199-0.36266l-2.8586-3.4773-0.44799 2.6026q-0.10667 0.512-0.53333 0.87466t-0.93865 0.36266-0.83199-0.36266q-0.29866-0.36266-0.19199-0.87466l2.1546-12.458q0.10666-0.51199 0.51199-0.87465 0.42666-0.36266 0.93865-0.36266t0.83199 0.36266q0.31999 0.36266 0.21333 0.87465l-1.3226 7.5732 4.0959-3.4773q0.40533-0.34133 0.91732-0.34133t0.83199 0.34133q0.29866 0.38399 0.19199 0.89598-0.064 0.49066-0.51199 0.87466l-3.3493 2.8586zm9.5519-7.8292q1.024 0 1.856 0.40532 0.85332 0.384 1.408 1.0666 0.55465 0.66133 0.78932 1.5786 0.23466 0.91732 0.064 1.9413-0.17067 1.024-0.72533 1.9413-0.55465 0.89599-1.344 1.5786-0.78932 0.66133-1.7706 1.0666-0.98132 0.384-2.0053 0.384-1.024 0-1.8773-0.384-0.83199-0.40532-1.3866-1.0666-0.55465-0.68265-0.78932-1.5786-0.23466-0.91732-0.064-1.9413 0.17067-1.024 0.72533-1.9413 0.55465-0.91732 1.344-1.5786 0.81065-0.68265 1.7706-1.0666 0.98132-0.40532 2.0053-0.40532zm-1.3013 7.4666q0.512 0 1.0026-0.192 0.49066-0.192 0.87466-0.53332 0.40532-0.34133 0.68265-0.78933 0.27733-0.44799 0.36266-0.95998 0.0853-0.51199-0.0427-0.95999-0.10667-0.46932-0.384-0.81065-0.27732-0.34133-0.70398-0.53332-0.42666-0.192-0.93866-0.192-0.51199 0-1.0026 0.192-0.46932 0.19199-0.87465 0.53332-0.38399 0.34133-0.66132 0.81065-0.27733 0.448-0.36266 0.95999-0.0853 0.51199 0.0213 0.95998 0.128 0.448 0.40533 0.78933 0.27732 0.34132 0.68265 0.53332 0.42666 0.192 0.93865 0.192zm14.97-7.4666q1.024 0 1.856 0.40532 0.85332 0.384 1.408 1.0666 0.55465 0.66133 0.78932 1.5786 0.23466 0.91732 0.064 1.9413-0.17067 1.024-0.72533 1.9413-0.55465 0.89599-1.344 1.5786-0.78933 0.66133-1.7706 1.0666-0.98132 0.384-2.0053 0.384-1.024 0-1.8773-0.384-0.83199-0.40532-1.3866-1.0666-0.55466-0.68265-0.78933-1.5786-0.23466-0.91732-0.064-1.9413t0.72532-1.9413 1.344-1.5786q0.81065-0.68265 1.7706-1.0666 0.98131-0.40532 2.0053-0.40532zm-1.3013 7.4666q0.512 0 1.0027-0.192 0.49065-0.192 0.87465-0.53332 0.40533-0.34133 0.68265-0.78933 0.27733-0.44799 0.36267-0.95998 0.0853-0.51199-0.0427-0.95999-0.10667-0.46932-0.38399-0.81065-0.27733-0.34133-0.70399-0.53332-0.42666-0.192-0.93866-0.192-0.51199 0-1.0026 0.192-0.46932 0.19199-0.87465 0.53332-0.38399 0.34133-0.66132 0.81065-0.27733 0.448-0.36266 0.95999-0.0853 0.51199 0.0213 0.95998 0.128 0.448 0.40533 0.78933 0.27733 0.34132 0.68265 0.53332 0.42666 0.192 0.93865 0.192zm8.6346 7.4666q-0.512 0-0.81066-0.36266t-0.21333-0.87466l2.176-12.458q0.0853-0.51199 0.51199-0.87465 0.42666-0.36266 0.93865-0.36266 0.384 0 0.63999 0.21333 0.256 0.19199 0.36266 0.51199 0.61866-0.34133 1.3226-0.53333 0.70399-0.19199 1.408-0.19199 1.024 0 1.856 0.40532 0.85332 0.384 1.408 1.0666 0.55465 0.66133 0.78932 1.5786 0.23466 0.89598 0.064 1.92-0.17067 1.024-0.72533 1.9413-0.55465 0.91732-1.344 1.6-0.78933 0.66133-1.7706 1.0666-0.98132 0.384-2.0053 0.384-0.68265 0-1.28-0.17067-0.59732-0.19199-1.088-0.51199l-0.76799 4.4159q-0.0853 0.512-0.53332 0.87466-0.42666 0.36266-0.93865 0.36266zm5.8879-12.437q-0.51199 0-1.0026 0.192-0.46932 0.19199-0.87465 0.53332-0.38399 0.34133-0.66132 0.78932t-0.36266 0.95999q-0.0853 0.51199 0.0213 0.98131 0.128 0.448 0.40533 0.78933 0.27733 0.34132 0.68265 0.53332 0.42666 0.192 0.93865 0.192 0.512 0 1.0027-0.192 0.49065-0.192 0.87465-0.53332 0.40533-0.34133 0.68265-0.78933 0.27733-0.46932 0.36267-0.98131 0.0853-0.512-0.0427-0.95999-0.10667-0.44799-0.38399-0.78932-0.27733-0.34133-0.70399-0.53332-0.42666-0.192-0.93866-0.192z"
                fill="#fff"
                aria-label="                 Heikoop            "
              />
            </g>
          </g>
        </g>
      </svg>
    </>
  )
}

export default Heikoop
